'use client';

import 'BomdisoftComponents/notifications/snackbars/styles.css';
import { Snack } from 'BomdisoftComponents/notifications/snackbars/snack';
import { toSavedCopyOfferItem } from 'BomdisoftComponents/pwa/register-service-worker/render';
import { getLanguageFromLocale } from '@bomdisoft/translations';
import { useParams } from 'next/navigation';

export type SavedCopyOfferProps = {
  onClose: () => void;
};

export const SavedCopyOffer = ({ onClose }: SavedCopyOfferProps) => {
  const params = useParams();
  const language = getLanguageFromLocale(params?.lang as string) ?? 'english';

  return (
    <div className='bomdisoft-snackbars-region' data-anchor='bottom-center' data-testid='saved-copy-offer'>
      <Snack item={toSavedCopyOfferItem(language, () => window.location.reload())} onClose={onClose} />
    </div>
  );
};
